import React from 'react';


import './testimonialItem.css';



function TestimonialItem(props) {
  return (
    <div className="testimonials--item">
        <div className="testimonial--quote">
            "{props.quote}"
        </div>
        <div className="sub--flex">
        <div>
            <div className="testimonial--person">
            -{props.name}
            </div>
            <div className="testimonial--title">
                <i>{props.title}</i>
            </div>
        </div>
        <div className="testimonial--pic--containter">
            <img src={props.image} className="testimonial--pic" alt="testimonial--alt"/>
        </div>
        </div>
    </div>
  );
}

export default TestimonialItem;
